import { supabase } from './supabase.js'
import { apiFetch } from './api.js'
import type { SupportedLanguage } from './constants.js'

/**
 * Persist the signed-in user's language preference so lifecycle emails (and any
 * future per-user localized output) go out in the language they actually use.
 *
 * Best-effort + fire-and-forget by design:
 *  - Anonymous visitors are a no-op — there's no account to associate yet; the
 *    preference gets captured on their next language change after logging in.
 *  - A network/API failure must NEVER break the language switch itself, so we
 *    only swallow + warn. The UI language already changed via the URL.
 */
export async function persistLanguagePreference(language: SupportedLanguage): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) return // anonymous — nothing to persist
    await apiFetch('/api/public/preferences/language', {
      method: 'PUT',
      body: { language },
    })
  } catch (err) {
    console.warn('[language-preference] could not persist preference:', err)
  }
}
